(function () {
    if (window.__textVideoProductsAssetLoaded) return;
    window.__textVideoProductsAssetLoaded = true;
    // 选择其他卡片时，暂停此前正在播放的站内播放器。
    function pauseCard(card) {
      var video = card.querySelector('video');
      if (video) video.pause();

      var iframe = card.querySelector('iframe');
      if (!iframe || !iframe.contentWindow) return;
      iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*');
      iframe.contentWindow.postMessage({ method: 'pause' }, '*');
    }

    // 仅克隆一次延迟播放器，将 data-src 提升为 src，然后开始播放。
    function loadCard(card) {
      if (card.classList.contains('is-loaded')) {
        var existingVideo = card.querySelector('video');
        if (existingVideo) existingVideo.play().catch(function () {});
        return;
      }

      var media = card.querySelector('[data-sv-media]');
      var template = card.querySelector('[data-sv-template]');
      if (!media || !template || !template.content || !template.content.firstElementChild) return;

      var player = template.content.firstElementChild.cloneNode(true);
      player.querySelectorAll('[data-src]').forEach(function (element) {
        element.src = element.dataset.src;
        element.removeAttribute('data-src');
      });
      if (player.dataset.src) {
        player.src = player.dataset.src;
        player.removeAttribute('data-src');
      }

      media.appendChild(player);
      card.classList.add('is-loaded');

      if (player.tagName === 'VIDEO') {
        player.load();
        player.play().catch(function () {});
      }
    }

    // 将产品模板复制到目标容器，供普通产品栏和灯箱共同使用。
    function replaceProducts(card, content) {
      var template = card.querySelector('[data-sv-products-template]');
      content.replaceChildren();
      if (!template || !template.content) return false;

      content.appendChild(template.content.cloneNode(true));
      return true;
    }

    function renderProducts(root, card) {
      var shelf = root.querySelector('[data-sv-shelf]');
      var content = root.querySelector('[data-sv-shelf-content]');
      var controls = root.querySelector('[data-sv-shelf-concontrolstrols]');
      if (!shelf || !content) return;

      shelf.classList.remove('is-visible');
      if (controls) controls.hidden = true;

      if (!replaceProducts(card, content)) {
        shelf.setAttribute('aria-hidden', 'true');
        return;
      }

      shelf.setAttribute('aria-hidden', 'false');
      window.requestAnimationFrame(function () {
        shelf.classList.add('is-visible');
        setupProductShelf(root);
      });
    }

    // 仅在当前产品行确实溢出时显示箭头，并跟踪首尾位置。
    function setupProductShelf(root) {
      var shelf = root.querySelector('[data-sv-shelf]');
      var products = shelf && shelf.querySelector('.sv__products');
      var controls = shelf && shelf.querySelector('[data-sv-shelf-controls]');
      var previous = shelf && shelf.querySelector('[data-sv-products-prev]');
      var next = shelf && shelf.querySelector('[data-sv-products-next]');
      if (!products || !controls || !previous || !next) return;

      function update() {
        var maximum = Math.max(0, products.scrollWidth - products.clientWidth);
        /* 浏览器完成滚动吸附后，滑轨与任一边缘可能仍有几个小数像素的偏差。 */
        var edgeTolerance = 5;
        controls.hidden = maximum <= 2;
        previous.disabled = products.scrollLeft <= edgeTolerance;
        next.disabled = products.scrollLeft >= maximum - edgeTolerance;
      }

      if (products.dataset.svShelfReady !== 'true') {
        products.dataset.svShelfReady = 'true';
        products.addEventListener('scroll', update, { passive: true });
      }
      update();
    }

    function scrollProducts(root, direction) {
      var products = root.querySelector('[data-sv-shelf] .sv__products');
      if (!products) return;
      products.scrollBy({ left: direction * Math.max(220, products.clientWidth * .72), behavior: 'smooth' });
    }

    function renderLightboxProducts(root, card) {
      var related = root.querySelector('[data-sv-lightbox-related]');
      var content = root.querySelector('[data-sv-lightbox-products]');
      if (!related || !content) return;

      related.classList.remove('is-visible');
      related.setAttribute('aria-hidden', 'true');
      if (!replaceProducts(card, content)) return;

      related.classList.add('is-visible');
      related.setAttribute('aria-hidden', 'false');
    }

    function selectCard(root, card) {
      root.querySelectorAll('[data-sv-card]').forEach(function (item) {
        item.classList.toggle('is-active', item === card);
        if (item !== card) pauseCard(item);
      });
    }

    function activateCard(root, card) {
      selectCard(root, card);
      loadCard(card);
      renderProducts(root, card);
    }

    function restoreLightboxPlayer(root) {
      var modal = root.querySelector('[data-sv-lightbox]');
      var stage = root.querySelector('[data-sv-lightbox-player]');
      var card = modal && modal._svCard;
      var player = stage && stage.querySelector('video, iframe');
      var media = card && card.querySelector('[data-sv-media]');

      if (player && media) media.appendChild(player);
      if (modal) modal._svCard = null;
    }

    function updateLightboxTop(root) {
      var modal = root.querySelector('[data-sv-lightbox]');
      if (!modal) return;

      var topOffset = 0;
      document.querySelectorAll('header, [role="banner"], sticky-header, theme-header, #header, .header-section, .shopify-section-group-header-group').forEach(function (element) {
        if (element.closest('[data-sv-lightbox]')) return;
        var style = window.getComputedStyle(element);
        var rect = element.getBoundingClientRect();
        var isPinned = style.position === 'fixed' || style.position === 'sticky';
        var isVisible = style.display !== 'none' && style.visibility !== 'hidden' && rect.height > 0;
        if (isPinned && isVisible && rect.top <= 2 && rect.bottom > 0 && rect.height < window.innerHeight * .4) {
          topOffset = Math.max(topOffset, Math.round(rect.bottom) + 12);
        }
      });

      modal.style.setProperty('--sv-lightbox-top', topOffset + 'px');
      return topOffset;
    }

    function sizeLightbox(root, card) {
      var modal = root.querySelector('[data-sv-lightbox]');
      var dialog = root.querySelector('.sv__lightbox-dialog');
      var stage = root.querySelector('[data-sv-lightbox-player]');
      var media = card && card.querySelector('[data-sv-media]');
      var player = stage && stage.querySelector('video, iframe');
      if (!modal || !dialog || !stage || !media) return;

      var ratioText = media.style.getPropertyValue('--sv-ratio') || window.getComputedStyle(media).aspectRatio || '16 / 9';
      var ratioParts = ratioText.split('/');
      var ratio = Number(ratioParts[0]) / Number(ratioParts[1]);
      if (player && player.tagName === 'VIDEO' && player.videoWidth && player.videoHeight) {
        ratio = player.videoWidth / player.videoHeight;
      }
      if (!isFinite(ratio) || ratio <= 0) ratio = 16 / 9;

      var topOffset = parseFloat(modal.style.getPropertyValue('--sv-lightbox-top')) || 0;
      var modalStyle = window.getComputedStyle(modal);
      var caption = root.querySelector('.sv__lightbox-caption');
      var related = root.querySelector('[data-sv-lightbox-related].is-visible');
      var modalPadding = (parseFloat(modalStyle.paddingLeft) || 0) * 2;
      var captionHeight = Math.max(54, caption ? caption.scrollHeight : 0);
      /* 仅在右侧空间充足且不会移动居中视频时浮动显示产品。 */
      var useSideProducts = Boolean(related && ratio < .9 && window.innerWidth >= 1100);
      var sideProductsWidth = useSideProducts ? Math.min(320, Math.max(280, window.innerWidth * .21)) : 0;
      dialog.classList.toggle('has-side-products', useSideProducts);
      dialog.style.setProperty('--sv-side-products-width', Math.round(sideProductsWidth) + 'px');
      /* 布局类变更后再读取内边距，确保透明侧栏模式尺寸准确。 */
      var dialogStyle = window.getComputedStyle(dialog);
      var dialogPadding = (parseFloat(dialogStyle.paddingLeft) || 0) * 2;

      var relatedHeight = related && !useSideProducts ? Math.max(84, related.scrollHeight) : 0;
      var maxPlayerWidth = Math.max(240, Math.min(1152, window.innerWidth - modalPadding - dialogPadding));
      var maxPlayerHeight = Math.max(160, window.innerHeight - topOffset - modalPadding - dialogPadding - captionHeight - relatedHeight);
      var playerWidth = Math.min(maxPlayerWidth, maxPlayerHeight * ratio);
      var playerHeight = playerWidth / ratio;

      modal.style.setProperty('--sv-lightbox-width', Math.round(playerWidth + dialogPadding) + 'px');
      modal.style.setProperty('--sv-lightbox-height', Math.round(playerHeight + dialogPadding + captionHeight + relatedHeight) + 'px');
      /* 产品较少时让列表自适应收缩；产品较多时将高度限制为视频对话框高度。 */
      dialog.style.setProperty('--sv-side-products-max-height', Math.round(playerHeight + captionHeight) + 'px');
    }

    function openLightbox(root, card) {
      var modal = root.querySelector('[data-sv-lightbox]');
      var stage = root.querySelector('[data-sv-lightbox-player]');
      if (!modal || !stage || !card) return;

      restoreLightboxPlayer(root);
      activateCard(root, card);

      var media = card.querySelector('[data-sv-media]');
      var player = media && media.querySelector('video, iframe');
      if (!player) return;

      stage.replaceChildren(player);
      modal._svCard = card;

      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-sv-card]:not([data-sv-loop-clone])'));
      var index = cards.indexOf(card);
      var title = card.querySelector('.sv__title');
      var titleTarget = modal.querySelector('[data-sv-lightbox-title]');
      var countTarget = modal.querySelector('[data-sv-lightbox-count]');
      if (titleTarget) titleTarget.textContent = title ? title.textContent.trim() : '';
      if (countTarget) countTarget.textContent = (index + 1) + ' / ' + cards.length;
      renderLightboxProducts(root, card);

      updateLightboxTop(root);
      root.classList.add('is-lightbox-open');
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('sv-lightbox-open');
      sizeLightbox(root, card);

      if (player.tagName === 'VIDEO' && player.dataset.svSizeBound !== 'true') {
        player.dataset.svSizeBound = 'true';
        player.addEventListener('loadedmetadata', function () { sizeLightbox(root, card); });
      }

      if (player.tagName === 'VIDEO') player.play().catch(function () {});
      var closeButton = modal.querySelector('.sv__lightbox-exit');
      if (closeButton) closeButton.focus();
    }

    function closeLightbox(root) {
      var modal = root.querySelector('[data-sv-lightbox]');
      var activeCard = modal && modal._svCard;
      restoreLightboxPlayer(root);

      root.classList.remove('is-lightbox-open');
      if (modal) {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
      }
      document.body.classList.remove('sv-lightbox-open');

      var expandButton = activeCard && activeCard.querySelector('[data-sv-expand]');
      if (expandButton) expandButton.focus();
    }

    function switchLightbox(root, direction) {
      var modal = root.querySelector('[data-sv-lightbox]');
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-sv-card]:not([data-sv-loop-clone])'));
      var current = modal && modal._svCard;
      if (!current || cards.length < 2) return;

      var index = cards.indexOf(current);
      var nextIndex = (index + direction + cards.length) % cards.length;
      openLightbox(root, cards[nextIndex]);
      cards[nextIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    // 绑定一个分区实例；数据标记可防止主题编辑器重复添加监听器。
    function initShowcase(root) {
      if (!root || root.dataset.svReady === 'true') return;
      root.dataset.svReady = 'true';

      var rail = root.querySelector('[data-sv-rail]');
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-sv-card]'));
      var loopTimer;
      var pointerActive = false;
      var mobileLoop = window.matchMedia('(max-width: 767px)').matches;
      var loopEnabled = rail && cards.length > 1;

      function centerPosition(card) {
        return rail.scrollLeft + card.getBoundingClientRect().left - rail.getBoundingClientRect().left - (rail.clientWidth - card.getBoundingClientRect().width) / 2;
      }

      function jumpTo(position) {
        rail.scrollTo({ left: position, behavior: 'instant' });
      }

      if (loopEnabled) {
        function makeLoopClone(card, index) {
          var clone = card.cloneNode(true);
          clone.dataset.svLoopClone = String(index);
          clone.classList.remove('is-active', 'is-loaded');
          clone.querySelectorAll('video, iframe').forEach(function (player) { player.remove(); });
          clone.removeAttribute('id');
          clone.removeAttribute('data-shopify-editor-block');
          clone.querySelectorAll('[id]').forEach(function (element) { element.removeAttribute('id'); });
          return clone;
        }
        rail.prepend(makeLoopClone(cards[cards.length - 1], cards.length - 1));
        rail.append(makeLoopClone(cards[0], 0));
        if (mobileLoop) jumpTo(centerPosition(cards[0]));
      }

      function normalizeLoop() {
        if (!loopEnabled || !mobileLoop || pointerActive) return;
        var first = centerPosition(cards[0]);
        var last = centerPosition(cards[cards.length - 1]);
        var step = centerPosition(cards[1]) - first;
        var cycle = last - first + step;
        if (rail.scrollLeft < first - step / 2) jumpTo(rail.scrollLeft + cycle);
        else if (rail.scrollLeft > last + step / 2) jumpTo(rail.scrollLeft - cycle);
      }

      function handleLoopScroll() {
        window.clearTimeout(loopTimer);
        loopTimer = window.setTimeout(normalizeLoop, 160);
      }

      function handlePointerDown() { pointerActive = true; }
      function handlePointerUp() { pointerActive = false; handleLoopScroll(); }

      if (loopEnabled) {
        rail.addEventListener('scroll', handleLoopScroll, { passive: true });
        rail.addEventListener('pointerdown', handlePointerDown, { passive: true });
        window.addEventListener('pointerup', handlePointerUp, { passive: true });
        window.addEventListener('pointercancel', handlePointerUp, { passive: true });
      }

      // 每次移动一个卡片宽度；到达首尾时循环到另一端。
      function scrollRail(direction) {
        if (!rail || !cards.length) return;

        if (mobileLoop && loopEnabled) {
          normalizeLoop();
          var positions = cards.map(centerPosition);
          var step = positions[1] - positions[0];
          var currentIndex = Math.round((rail.scrollLeft - positions[0]) / step);
          rail.scrollTo({ left: positions[0] + (currentIndex + direction) * step, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          return;
        }

        var card = cards[0];
        var distance = card ? card.getBoundingClientRect().width + 14 : rail.clientWidth;
        var maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
        var atStart = rail.scrollLeft <= 2;
        var atEnd = maxScroll - rail.scrollLeft <= 2;

        if (direction > 0 && atEnd) {
          rail.scrollTo({ left: 0, behavior: 'smooth' });
          return;
        }

        if (direction < 0 && atStart) {
          rail.scrollTo({ left: maxScroll, behavior: 'smooth' });
          return;
        }

        rail.scrollBy({ left: direction * distance, behavior: 'smooth' });
      }


      // 从稳定的分区根节点委托控件事件，避免编辑器或应用重新渲染时丢失监听器。
      root.addEventListener('click', function (event) {
        if (event.target.closest('[data-sv-lightbox-close]')) {
          closeLightbox(root);
          return;
        }

        if (event.target.closest('[data-sv-modal-prev]')) {
          switchLightbox(root, -1);
          return;
        }

        if (event.target.closest('[data-sv-modal-next]')) {
          switchLightbox(root, 1);
          return;
        }

        if (event.target.closest('[data-sv-products-prev]')) {
          scrollProducts(root, -1);
          return;
        }

        if (event.target.closest('[data-sv-products-next]')) {
          scrollProducts(root, 1);
          return;
        }

        var expandButton = event.target.closest('[data-sv-expand]');
        if (expandButton && root.contains(expandButton)) {
          var expandedCard = expandButton.closest('[data-sv-card]');
          if (expandedCard.dataset.svLoopClone !== undefined) expandedCard = cards[Number(expandedCard.dataset.svLoopClone)];
          openLightbox(root, expandedCard);
          return;
        }

        var playButton = event.target.closest('[data-sv-play]');
        if (playButton && root.contains(playButton)) {
          var card = playButton.closest('[data-sv-card]');
          if (!card) return;
          if (card.dataset.svLoopClone !== undefined) card = cards[Number(card.dataset.svLoopClone)];

          activateCard(root, card);
          card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          return;
        }

        if (event.target.closest('[data-sv-prev]')) scrollRail(-1);
        if (event.target.closest('[data-sv-next]')) scrollRail(1);
      });

      /* 缩略图消失后原生控件仍可点击；重新播放时保持产品同步。 */
      root.addEventListener('play', function (event) {
        var video = event.target.closest && event.target.closest('video');
        var card = video && video.closest('[data-sv-card]');
        if (!card || card.classList.contains('is-active')) return;

        selectCard(root, card);
        renderProducts(root, card);
      }, true);

      root.addEventListener('keydown', function (event) {
        var modal = root.querySelector('[data-sv-lightbox].is-open');
        if (!modal) return;
        if (event.key === 'Escape') closeLightbox(root);
        if (event.key === 'ArrowLeft') switchLightbox(root, -1);
        if (event.key === 'ArrowRight') switchLightbox(root, 1);
      });

      function handleResize() {
        var isMobile = window.matchMedia('(max-width: 767px)').matches;
        if (loopEnabled && isMobile !== mobileLoop) {
          mobileLoop = isMobile;
          jumpTo(isMobile ? centerPosition(cards[0]) : 0);
        }
        setupProductShelf(root);
        var modal = root.querySelector('[data-sv-lightbox].is-open');
        if (modal) {
          updateLightboxTop(root);
          sizeLightbox(root, modal._svCard);
        }
      }

      window.addEventListener('resize', handleResize);
      root._svCleanup = function () {
        window.removeEventListener('resize', handleResize);
        window.clearTimeout(loopTimer);
        if (loopEnabled) {
          rail.removeEventListener('scroll', handleLoopScroll);
          rail.removeEventListener('pointerdown', handlePointerDown);
          window.removeEventListener('pointerup', handlePointerUp);
          window.removeEventListener('pointercancel', handlePointerUp);
          rail.querySelectorAll('[data-sv-loop-clone]').forEach(function (clone) { clone.remove(); });
        }
      };
    }

    function initAll(scope) {
      scope.querySelectorAll('scrolling-video').forEach(initShowcase);
    }

    function destroyAll(scope) {
      scope.querySelectorAll('scrolling-video').forEach(function (root) {
        if (root._svCleanup) root._svCleanup();
        root.querySelectorAll('[data-sv-tiktok-url]').forEach(function (poster) {
          if (poster._svTikTokRetryTimer) window.clearTimeout(poster._svTikTokRetryTimer);
          delete poster._svTikTokRetryTimer;
        });
        delete root._svCleanup;
        root.removeAttribute('data-sv-ready');
      });
    }

    // TikTok 不会在 Liquid 中提供可预测的缩略图 URL，因此通过轻量级
    // oEmbed 元数据获取缩略图；真实播放器仍保持延迟加载。
    var TIKTOK_POSTER_MAX_ATTEMPTS = 3;
    var TIKTOK_POSTER_RETRY_DELAY = 600;

    function requestTikTokPoster(poster) {
      var state = poster.dataset.svTikTokPosterState;
      if (state === 'loading' || state === 'waiting' || state === 'loaded' || state === 'failed') return;

      if (poster.querySelector('img')) {
        poster.dataset.svTikTokPosterState = 'loaded';
        return;
      }

      var attempt = Number(poster.dataset.svTikTokPosterAttempts || 0) + 1;
      var endpoint = 'https://www.tiktok.com/oembed?url=' + encodeURIComponent(poster.dataset.svTiktokUrl);
      poster.dataset.svTikTokPosterAttempts = String(attempt);
      poster.dataset.svTikTokPosterState = 'loading';

      fetch(endpoint)
        .then(function (response) {
          if (!response.ok) throw new Error('TikTok poster request failed');
          return response.json();
        })
        .then(function (data) {
          if (!data || !data.thumbnail_url) throw new Error('TikTok poster is unavailable');
          if (!poster.querySelector('img')) {
            var image = document.createElement('img');
            image.src = data.thumbnail_url;
            image.alt = poster.getAttribute('aria-label') || '';
            image.width = 1200;
            image.height = 675;
            image.loading = 'lazy';
            poster.prepend(image);
          }

          poster.dataset.svTikTokPosterState = 'loaded';
          delete poster.dataset.svTikTokPosterAttempts;
        })
        .catch(function () {
          if (attempt >= TIKTOK_POSTER_MAX_ATTEMPTS) {
            poster.dataset.svTikTokPosterState = 'failed';
            return;
          }

          poster.dataset.svTikTokPosterState = 'waiting';
          poster._svTikTokRetryTimer = window.setTimeout(function () {
            delete poster._svTikTokRetryTimer;
            poster.dataset.svTikTokPosterState = 'idle';
            requestTikTokPoster(poster);
          }, TIKTOK_POSTER_RETRY_DELAY * attempt);
        });
    }

    function loadTikTokPosters(scope) {
      scope.querySelectorAll('[data-sv-tiktok-url]').forEach(requestTikTokPoster);
    }

    // Velocite 通常通过 lazysizes 将 data-src/data-srcset 转换为实际资源。部分主题
    // 预览不会加载该库，因此仅在这种失败情况下启用现有 URL。
    function recoverMissingLazyLoader(scope) {
      if (window.lazySizes) return;

      scope.querySelectorAll('img.lazyload').forEach(function (image) {
        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
        if (image.dataset.src) image.src = image.dataset.src;
        if (image.dataset.sizes === 'auto') image.sizes = 'auto';
        image.classList.remove('lazyload');
        image.classList.add('lazyloaded');
      });
    }

    function initSection(scope) {
      initAll(scope);
      loadTikTokPosters(scope);
      recoverMissingLazyLoader(scope);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initSection(document); });
    } else {
      initSection(document);
    }

    // 在 Shopify 主题编辑器重新渲染或移除分区时初始化并清理事件。
    document.addEventListener('shopify:section:load', function (event) { initSection(event.target); });
    document.addEventListener('shopify:section:unload', function (event) { destroyAll(event.target); });
  })();
